<template>
  <div>
    <mapheader class="mapheader"></mapheader>
    <meun class="meun"></meun>
    <scrollcompare></scrollcompare>
    <barAnimation></barAnimation>
    <layerlist></layerlist>
    <full></full>
    <flyhome></flyhome>
    <bottombar></bottombar>
  </div>
</template>

<script>
import mapheader from "@/components/layout/mapheader";
import meun from "@/components/layout/meun";
import scrollcompare from "@/components/layout/scrollCompare";
import barAnimation from "@/components/layout/barAnimation";
import layerlist from "@/components/layout/layerlist";
import full from "@/components/layout/full";
import flyhome from "@/components/layout/flyhome";
import bottombar from "@/components/layout/bottombar";

export default {
  name: "layout",
  data() {
    return {
      data: [],
      showchart: false,
      showList: true,
    };
  },
  methods: {},
  mounted() {
    map3d_viewer.viewer.mouseHandlerManager.listen("showChart", (config) => {
      this.showchart = config;
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("showList", (config) => {
      this.showList = config;
    });
  },
  components: {
    mapheader: mapheader,
    meun: meun,
    scrollcompare: scrollcompare,
    barAnimation: barAnimation,
    layerlist: layerlist,
    full: full,
    flyhome: flyhome,
    bottombar: bottombar,
  },
};
</script>

<style scoped>
.mapheader {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue